import { FC, ReactElement, useEffect } from 'react';
import { useFormikContext } from 'formik';
import i18next from 'i18next';
import ReactRouterPrompt from 'react-router-prompt';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { TrainingPlanFormValues } from '../trainingPlan.types';

const UnsavedChangesPrompt: FC = () => {
  const { dirty, isSubmitting } = useFormikContext<TrainingPlanFormValues>();
  const hasUnsavedChanges = dirty && !isSubmitting;

  useEffect(() => {
    if (!hasUnsavedChanges) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return (
    <ReactRouterPrompt when={hasUnsavedChanges}>
      {({ isActive, onConfirm, onCancel }): ReactElement => (
        <ConfirmationModal
          show={isActive}
          title={i18next.t('generic.unsavedChanges')}
          body={<p>{i18next.t('generic.unsavedChangesConfirm')}</p>}
          buttonPositive={i18next.t('generic.leaveWithoutSaving')}
          buttonNegative={i18next.t('generic.cancel')}
          onPositive={onConfirm}
          onNegative={onCancel}
        />
      )}
    </ReactRouterPrompt>
  );
};

export default UnsavedChangesPrompt;
